import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    username: null,
    permissions: [],
  },
  reducers: {
    loginStore: (state, action) => {
      state.username = action.payload;
    },
    setUserPermissions: (state, action) => {
      state.permissions = action.payload;
    },
    logout: (state) => {
      state.username = null;
      state.permissions = [];
    },
  },
});

export const { loginStore, logout, setUserPermissions } = userSlice.actions;
export default userSlice.reducer;
